import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=b87658f8&scoped=true"
import script from "./Preview.vue?vue&type=script&lang=js"
export * from "./Preview.vue?vue&type=script&lang=js"
import style0 from "./Preview.vue?vue&type=style&index=0&id=b87658f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87658f8",
  null
  
)

export default component.exports